export enum Alignment {
	TopLeft = "topLeft",
	Top = "top",
	TopRight = "topRight",
	Left = "left",
	Center = "center",
	Right = "right",
	BottomLeft = "bottomLeft",
	Bottom = "bottom",
	BottomRight = "bottomRight"
}

export const isATopAlignment = (alignment: Alignment) => {
	return alignment === Alignment.TopLeft || alignment === Alignment.Top || alignment === Alignment.TopRight
}

export const isALeftAlignment = (alignment: Alignment) => {
	return alignment === Alignment.TopLeft || alignment === Alignment.Left || alignment === Alignment.BottomLeft
}

export const isARightAlignment = (alignment: Alignment) => {
	return alignment === Alignment.TopRight || alignment === Alignment.Right || alignment === Alignment.BottomRight
}

export const isABottomAlignment = (alignment: Alignment) => {
	return alignment === Alignment.BottomLeft || alignment === Alignment.Bottom || alignment === Alignment.BottomRight
}

export const isAVerticallyCenterAlignment = (alignment: Alignment) => {
	return alignment === Alignment.Left || alignment === Alignment.Center || alignment === Alignment.Right
}

export const isAHorizontallyCenterAlignment = (alignment: Alignment) => {
	return alignment === Alignment.Top || alignment === Alignment.Center || alignment === Alignment.Bottom
}

/**
 * Reduces a 9-point alignment to a 3-point alignment.
 * @param alignment The alignment to reduce.
 * @param toVertical Whether to reduce to a vertical alignment. If false, will reduce to a horizontal alignment.
 * @returns The reduced alignment.
 */
export const reduceAlignment = (alignment: Alignment, toVertical: boolean) => {
	if (toVertical) {
		if (isATopAlignment(alignment)) {
			return Alignment.Top
		} else if (isABottomAlignment(alignment)) {
			return Alignment.Bottom
		} else {
			return Alignment.Center
		}
	} else {
		if (isALeftAlignment(alignment)) {
			return Alignment.Left
		} else if (isARightAlignment(alignment)) {
			return Alignment.Right
		} else {
			return Alignment.Center
		}
	}
}
